import {
  ADD_FAVOURITE_SECURITY,
  ADD_FAVOURITE_SECURITY_SUCCESS,
  FETCH_SECURITY,
  FETCH_SECURITY_SUCCESS,
  FETCH_ALL_SECURITY,
  FETCH_ALL_SECURITY_SUCCESS,
  FILTER_SECURITY,
  GET_ALL_SECURITY,
  GET_UNSELECTED_ALL_SECURITY,
  HANDLE_SECURITY_REQUEST_CLOSE,
  HIDE_SECURITY_LOADER,
  SHOW_SECURITY_LOADER,
  ON_ADD_SECURITY,
  ON_ALL_SECURITY_SELECT,
  ON_SECURITY_CLOSE,
  ON_SECURITY_SELECT,
  ON_DELETE_SECURITY,
  ON_DELETE_SECURITY_SUCCESS,
  ON_FILTER_SELECTED_SECURITY,
  ON_FILTER_SECURITY_OPTION_SELECT,
  ON_SAVE_SECURITY,
  ON_SAVE_SECURITY_SUCCESS,
  ON_TOGGLE_SECURITY_DRAWER,
  SHOW_SECURITY_MESSAGE,
  UPDATE_SEARCH_SECURITY,
} from 'constants/ActionTypes';

export const fetchSecurity = (payload) => {
  return {
      type: FETCH_SECURITY,
      payload
  };
};
export const fetchSecuritySuccess = (payload) => {
  return {
      type: FETCH_SECURITY_SUCCESS,
      payload
  };
};
export const fetchSecuritys = () => {
  return {
      type: FETCH_ALL_SECURITY
  };
};
export const fetchSecuritysSuccess = (payload) => {
  return {
      type: FETCH_ALL_SECURITY_SUCCESS,
      payload
  };
};
export const showSecurityMessage = (message) => {
  return {
      type: SHOW_SECURITY_MESSAGE,
      payload: message
  };
};
export const addFavouriteSecurity = (payload) => {
  return {
      type: ADD_FAVOURITE_SECURITY,
      payload
  };
};
export const addFavouriteSecuritySuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_SECURITY_SUCCESS,
      payload
  };
};
export const onSecuritySelect = (payload) => {
  return {
      type: ON_SECURITY_SELECT,
      payload
  };
};
export const onAddSecurity = () => {
  return {
      type: ON_ADD_SECURITY,
      payload: ''
  };
};
export const onSecurityClose = () => {
  return {
      type: ON_SECURITY_CLOSE,
      payload: ''
  };
};
export const onFilterSecurityOptionSelect = (payload) => {
  return {
      type: ON_FILTER_SECURITY_OPTION_SELECT,
      payload
  };
};
export const onSaveSecurity = (payload) => {
  return {
      type: ON_SAVE_SECURITY,
      payload
  };
};
export const onSaveSecuritySuccess = (data) => {
  return {
      type: ON_SAVE_SECURITY_SUCCESS,
      payload: data
  };
};
export const onDeleteSecurity = (payload) => {
  return {
      type: ON_DELETE_SECURITY,
      payload
  };
};
export const onDeleteSecuritySuccess = (payload) => {
  return {
      type: ON_DELETE_SECURITY_SUCCESS,
      payload
  };
};
export const onFilterSelectedSecurity = () => {
  return {
      type: ON_FILTER_SELECTED_SECURITY,
      payload: ''
  };
};
export const filterSecurity = (payload) => {
  return {
      type: FILTER_SECURITY,
      payload
  };
};
export const getAllSecurity = () => {
  return {
      type: GET_ALL_SECURITY,
      payload: ''
  };
};
export const getUnselectedAllSecurity = () => {
  return {
      type: GET_UNSELECTED_ALL_SECURITY,
      payload: ''
  };
};
export const onAllSecuritySelect = () => {
  return {
      type: ON_ALL_SECURITY_SELECT,
      payload: ''
  };
};
export const updateSearchSecurity = (payload) => {
  return {
      type: UPDATE_SEARCH_SECURITY,
      payload
  };
};
export const onToggleSecurityDrawer = () => {
  return {
      type: ON_TOGGLE_SECURITY_DRAWER,
  };
};
export const handleSecurityRequestClose = () => {
  return {
      type: HANDLE_SECURITY_REQUEST_CLOSE,
  };
};
export const showSecurityLoader = () => {
  return {
      type: SHOW_SECURITY_LOADER,
  };
};
export const hideSecurityLoader = () => {
  return {
      type: HIDE_SECURITY_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/security.js